import {
    Checkbox as AnvilCheckbox,
    CheckboxProps as AnvilCheckboxProps,
} from '@servicetitan/anvil2';
import { Controller, useFormContext } from 'react-hook-form';

type CheckboxProps = Omit<AnvilCheckboxProps, 'onChange'> & {
    name: string;
    onChange?: (checked: boolean) => void;
};

export const Checkbox = ({ onChange, ...props }: CheckboxProps) => {
    const { control } = useFormContext();
    return (
        <Controller
            name={props.name}
            control={control}
            render={({ field }) => (
                <AnvilCheckbox
                    {...props}
                    {...field}
                    checked={field.value}
                    onChange={e => {
                        field.onChange(e?.target.checked ?? false);
                        onChange?.(e?.target.checked ?? false);
                    }}
                />
            )}
        />
    );
};
